import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();

  const productLinks = [
    [t("footer.productLinks.film"), "/#produit"],
    [t("footer.productLinks.config"), "/#configurateur"],
    [t("footer.productLinks.specs"), "/#specifications"],
    [t("footer.productLinks.faq"), "/#faq"],
  ];
  const maisonLinks = [
    [t("footer.maisonLinks.film"), "/#produit"],
    [t("footer.maisonLinks.install"), "/contact"],
    [t("footer.maisonLinks.samples"), "/contact"],
    [t("footer.maisonLinks.contact"), "/contact"],
    ["contact@smartxglass.ch", "mailto:contact@smartxglass.ch"],
  ];
  const legalLinks = [
    [t("footer.legalLinks.cgv"), "/cgv"],
    [t("footer.legalLinks.privacy"), "/privacy"],
    [t("footer.legalLinks.cookies"), "/cookies"],
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] border-t border-[#2a2422] pt-16 sm:pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-12 sm:mb-16">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img src="/brand/smartxglass-logo.png" alt="smartxglass" className="h-14 sm:h-16 w-auto logo-blink-x" />
            </div>
            <p className="text-[#cbc1ad] max-w-md text-sm leading-relaxed">{t("footer.desc")}</p>
          </div>
          <FooterCol title={t("footer.product")} links={productLinks} />
          <FooterCol title={t("footer.maison")} links={maisonLinks} />
          <FooterCol title={t("footer.legal")} links={legalLinks} />
        </div>

        <div className="hairline mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-3 text-[10px] sm:text-xs text-[#7a716a] uppercase tracking-[0.22em] sm:tracking-[0.25em] text-center md:text-left">
          <span>{t("footer.copy")}</span>
          <span>{t("footer.payment")}</span>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div className="md:col-span-2">
    <h4 className="text-xs uppercase tracking-[0.28em] text-[#d89557] mb-5">{title}</h4>
    <ul className="space-y-3">
      {links.map(([label, href]) => (
        <li key={label}>
          <a href={href} className="text-sm text-[#cbc1ad] hover:text-[#f4ede0] transition">
            {label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
